export default __webpack_public_path__ + "static/media/Sycamore Icons-04.3120ad3e.svg";